import { render, staticRenderFns } from "./PageMoved.vue?vue&type=template&id=0454cad5"
import script from "./PageMoved.vue?vue&type=script&lang=js"
export * from "./PageMoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports